import AssignmentPreview from './assignment_preview';

export default AssignmentPreview;
